import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { extractErrorMessage, notifyError } from './errorNotifier';

interface ExportRows {
  headers: string[];
  rows: string[][];
  filename: string;
  sheetName?: string;
}

export const exportRowsToXlsx = async ({
  headers,
  rows,
  filename,
  sheetName,
}: ExportRows) => {
  try {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(sheetName ?? 'Sheet1');

    worksheet.columns = headers.map((header) => ({ header, key: header, width: 40 }));
    worksheet.getRow(1).font = { bold: true };

    rows.forEach((row) => {
      worksheet.addRow(row);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `${filename}.xlsx`);
  } catch (error) {
    notifyError(extractErrorMessage(error));
  }
};

const escapeCsvCell = (value: string) => {
  if (/[",\r\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
};

export const exportRowsToCsv = ({
  headers,
  rows,
  filename,
}: Omit<ExportRows, 'sheetName'>) => {
  try {
    const lines = [
      headers.map(escapeCsvCell).join(','),
      ...rows.map((row) => row.map(escapeCsvCell).join(',')),
    ];
    const csv = '﻿' + lines.join('\r\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, `${filename}.csv`);
  } catch (error) {
    notifyError(extractErrorMessage(error));
  }
};
